import { useTranslation } from "react-i18next";import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';

export default function SimpleFooter() {const { t } = useTranslation();
  const { isDarkMode } = useTheme();
  return (
    <footer className={`${isDarkMode ? 'bg-zinc-950 border-white/[0.06]' : 'bg-white border-black/[0.1]'} border-t overflow-hidden transition-colors duration-300`}>
            {/* ── Links ── */}
            <div className="px-5 sm:px-8 md:px-16 py-12 sm:py-16 max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12">
                {/* Brand */}
                <div className="col-span-2 md:col-span-1">
                    <Link to="/" className="flex items-center gap-2.5 mb-5 group">
                        <img
              src={isDarkMode ? "/quadcores-dark.png" : "/quadcores-light.png"}
              alt="Quadcores Properties"
              className="h-7 w-auto opacity-80 group-hover:opacity-100 transition-opacity" />
            
                        <span style={{ fontSize: 13.5, fontWeight: 400, color: isDarkMode ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.85)', letterSpacing: '-0.2px', whiteSpace: 'nowrap' }}>
                            {t("quadcores_properties_3")}
                        </span>
                    </Link>
                    <p className={`${isDarkMode ? 'text-white/55' : 'text-zinc-800'} text-[13px] font-light leading-relaxed max-w-[200px] mb-6`}>
                        {t("the_apartment_management_platform_built_1")}
                    </p>
                </div>

                {/* Links */}
                {[
        { title: 'Platform', links: [['/#solutions', 'Solutions'], ['/#features', 'Features'], ['/#pricing', 'Pricing']] },
        { title: 'Company', links: [['/about', 'About'], ['/privacy', 'Privacy Policy'], ['/terms', 'Terms of Use']] },
        { title: 'Account', links: [['/register', 'Create account'], ['/login', 'Sign in'], ['/portal/tenant/login', 'Tenant Login'], ['/portal/owner/login', 'Owner Login']] }].
        map(({ title, links }) =>
        <div key={title}>
                        <p className={`text-[10px] font-medium ${isDarkMode ? 'text-white/55' : 'text-black/75'} tracking-[2px] uppercase mb-6`}>{title}</p>
                        <ul className="space-y-4">
                            {links.map(([href, label]) =>
            <li key={label}>
                                    {href.startsWith('/') ?
              <Link to={href} className={`text-[14px] ${isDarkMode ? 'text-white/70 hover:text-white/95' : 'text-black/85 hover:text-black/100'} font-light transition-colors`}>{label}</Link> :

              <a href={href} className={`text-[14px] ${isDarkMode ? 'text-white/70 hover:text-white/95' : 'text-black/85 hover:text-black/100'} font-light transition-colors`}>{label}</a>
              }
                                </li>
            )}
                        </ul>
                    </div>
        )}
            </div>

            {/* ── Bottom ── */}
            <div className={`px-5 sm:px-8 md:px-16 py-7 border-t ${isDarkMode ? 'border-white/[0.04]' : 'border-black/[0.06]'} flex flex-col sm:flex-row items-center justify-between gap-3 max-w-7xl mx-auto`}>
                <a href="https://www.quadcores.com/" target="_blank" rel="noopener noreferrer" className="text-[16px] text-red-700 hover:text-red-600 font-light transition-colors">{t("quadcores_1")}</a>
            </div>
        </footer>);

}